/* 單獨列傳：趙雲傳（設計見 docs/CAMPAIGN-ZHAOYUN.md）
 * 這一條列傳自己的章節、地圖都在這個檔案登錄，不用改 campaign/index.ts。
 * 地圖 id 一律加前綴「zhaoyun_」，免得和其他列傳撞名。
 * 長坂坡（liubei-6）、漢水空營（liubei-10）和劉備傳共用同一章（星數也共用），照年份排進來。 */
// @ts-nocheck
import zhaoyun1 from '../story/zhaoyun1.ts';
import zhaoyun2 from '../story/zhaoyun2.ts';
import zhaoyun3 from '../story/zhaoyun3.ts';
import zhaoyun4 from '../story/zhaoyun4.ts';
import bowang from '../maps/zhaoyun_bowang.ts';
import guiyang from '../maps/zhaoyun_guiyang.ts';
import jiang from '../maps/zhaoyun_jiang.ts';
import jigu from '../maps/zhaoyun_jigu.ts';

export default {
  list: { id: 'zhaoyun', name: '趙雲傳', years: '202–229', parts: [
    { name: '荊州篇', chapters: ['zhaoyun-1', 'liubei-6', 'zhaoyun-2', 'zhaoyun-3'] },
    { name: '漢中篇', chapters: ['liubei-10', 'zhaoyun-4'] },
  ] },
  chapters: [zhaoyun1, zhaoyun2, zhaoyun3, zhaoyun4],
  maps: { zhaoyun_bowang: bowang, zhaoyun_guiyang: guiyang, zhaoyun_jiang: jiang, zhaoyun_jigu: jigu },
};
